"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint no-magic-numbers: ["error", { "ignore": [1, 5, 24, 48, 60000, 3600000] }] */

function xMinutesAgo(dateStr) {
  var date = new Date(dateStr);
  var dateTime = date.getTime();

  if (isNaN(dateTime)) {
    return dateStr;
  }

  var now = Date.now();
  var deltaInMs = now - dateTime;
  var deltaInMinutes = Math.floor(deltaInMs / 60000);
  var deltaInHours = Math.floor(deltaInMs / 3600000);

  if (deltaInMinutes < 1) {
    return '剛剛';
  } else if (deltaInMinutes === 1) {
    return '一分鐘前';
  } else if (deltaInHours < 1) {
    return "".concat(deltaInMinutes, " \u5206\u9418\u524D");
  } else if (deltaInHours === 1) {
    return "\u4E00\u500B\u9418\u524D";
  } else if (deltaInHours < 5) {
    return "".concat(deltaInHours, " \u500B\u9418\u524D");
  } else if (deltaInHours <= 24) {
    return "\u4ECA\u65E5";
  } else if (deltaInHours <= 48) {
    return "\u6628\u65E5";
  } else if (window.Intl) {
    return new Intl.DateTimeFormat('zh-HANT').format(date);
  }

  return date.toLocaleString('zh-HANT', {
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

function botSaidSomething(avatarInitials, text) {
  return "Bot ".concat(avatarInitials, " \u8AAA\uFF1A").concat(text);
}

function userSaidSomething(avatarInitials, text) {
  return "\u4F7F\u7528\u8005 ".concat(avatarInitials, " \u8AAA\uFF1A").concat(text);
}

var _default = {
  FAILED_CONNECTION_NOTIFICATION: '接駁失敗。',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  INITIAL_CONNECTION_NOTIFICATION: '接駁中...',
  INTERRUPTED_CONNECTION_NOTIFICATION: '網絡暫時中斷，正嘗試再接駁…',
  RENDER_ERROR_NOTIFICATION: 'Render 失敗，請檢查控制台或與 Bot 開發人員聯絡。',
  SEND_FAILED_KEY: "\u7121\u6CD5\u767C\u9001\u3002{Retry}",
  SLOW_CONNECTION_NOTIFICATION: '接駁時間比平時長。',
  'Bot said something': botSaidSomething,
  'User said something': userSaidSomething,
  'X minutes ago': xMinutesAgo,
  'Adaptive Card parse error': 'Adaptive Card 解析失敗',
  'Adaptive Card render error': 'Adaptive Card render 失敗',
  Chat: '聊天',
  'Download file': '下載檔案',
  'Microphone off': '關掉麥克風',
  'Microphone on': '開啟麥克風',
  Left: '左',
  'Listening…': '正在聆聽…',
  'New messages': '新訊息',
  Retry: '重試',
  Right: '右',
  Send: '發送',
  Sending: '正在發送',
  Speak: '發言',
  'Starting…': '開始中…',
  Tax: '稅',
  Total: '總共',
  'Type your message': '請輸入您的訊息',
  'Upload file': '上載檔案',
  VAT: '消費稅'
};
exports.default = _default;